import React, { useState, useEffect } from 'react'
import { 
  Grid, 
  Card, 
  CardContent, 
  Typography, 
  CircularProgress, 
  Snackbar,
  Button,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  IconButton,
  Divider,
  useMediaQuery,
  Avatar,
  LinearProgress,
  Collapse
} from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { 
  Error as ErrorIcon, 
  TrendingUp, 
  TrendingDown,
  AttachMoney,
  ShoppingCart,
  People,
  Receipt as ReceiptIcon,
  Refresh,
  Star,
  Assessment,
  ExpandMore,
  ExpandLess,
  PieChart as PieChartIcon,
  BarChart as BarChartIcon,
  EuroSymbol
} from '@material-ui/icons'
import CountUp from 'react-countup'
import BilanService from '../../services/BilanService'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
    backgroundColor: '#f8fafc',
    minHeight: '100vh'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(2)
    }
  },
  title: {
    fontWeight: 600,
    color: '#1e293b',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  controls: {
    display: 'flex',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexDirection: 'column'
    }
  },
  selectControl: {
    minWidth: 200,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'white',
      borderRadius: 12
    }
  },
  statCard: {
    borderRadius: 16,
    boxShadow: '0 4px 20px rgba(0,0,0,0.02)',
    transition: 'all 0.3s ease',
    height: '100%',
    border: '1px solid #eef2f6',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 12px 40px rgba(0,0,0,0.06)',
      borderColor: theme.palette.primary.main
    }
  },
  statContent: {
    padding: theme.spacing(3),
    position: 'relative',
    overflow: 'hidden'
  },
  statIcon: {
    position: 'absolute',
    right: theme.spacing(2),
    top: theme.spacing(2),
    opacity: 0.1,
    fontSize: 60
  },
  statValue: {
    fontSize: '2rem',
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem'
    }
  },
  statLabel: {
    color: '#64748b',
    fontSize: '0.9rem',
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  statTrend: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    padding: theme.spacing(1, 1.5),
    backgroundColor: '#f8fafc',
    borderRadius: 20,
    width: 'fit-content'
  },
  positive: {
    color: '#10b981',
    fontWeight: 600
  },
  negative: {
    color: '#ef4444',
    fontWeight: 600
  },
  info: {
    color: '#3b82f6',
    fontWeight: 600
  },
  tableContainer: {
    borderRadius: 16,
    boxShadow: 'none',
    border: '1px solid #eef2f6',
    '& .MuiTableCell-head': {
      backgroundColor: '#f8fafc',
      color: '#1e293b',
      fontWeight: 600,
      fontSize: '0.9rem'
    }
  },
  productRow: {
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: '#f8fafc'
    }
  },
  chipModern: {
    borderRadius: 8,
    fontWeight: 600,
    fontSize: '0.75rem',
    height: 24
  },
  tvaBadge: {
    backgroundColor: '#e0f2fe',
    color: '#0369a1',
    fontWeight: 600,
    padding: theme.spacing(0.5, 1.5),
    borderRadius: 20,
    fontSize: '0.75rem',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '400px'
  },
  errorContainer: {
    backgroundColor: '#fef2f2',
    border: '1px solid #fee2e2',
    borderRadius: 12,
    padding: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3)
  },
  sectionTitle: {
    fontSize: '1.2rem',
    fontWeight: 600,
    color: '#1e293b',
    marginBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  divider: {
    margin: theme.spacing(3, 0),
    backgroundColor: '#eef2f6'
  },
  miniCard: {
    padding: theme.spacing(2),
    backgroundColor: '#f8fafc',
    borderRadius: 12,
    border: '1px solid #eef2f6',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#f1f5f9'
    }
  },
  avatarIcon: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    width: 40,
    height: 40,
    borderRadius: 12
  },
  progressBar: {
    height: 8,
    borderRadius: 4,
    backgroundColor: '#eef2f6',
    marginTop: theme.spacing(1),
    '& .MuiLinearProgress-bar': {
      borderRadius: 4
    }
  },
  distributionItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.5),
    borderBottom: '1px solid #eef2f6',
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  colorDot: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    marginRight: theme.spacing(1)
  },
  metricCard: {
    textAlign: 'center',
    padding: theme.spacing(2),
    backgroundColor: 'white',
    borderRadius: 12,
    border: '1px solid #eef2f6'
  },
  expandButton: {
    marginTop: theme.spacing(1),
    width: '100%',
    justifyContent: 'center',
    color: '#64748b'
  }
}));

// Couleurs pour les graphiques
const CHART_COLORS = {
  ESPECE: '#10b981',
  WAVE: '#3b82f6',
  OM: '#f59e0b',
  default: '#94a3b8'
};

function Bilan() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [bilanData, setBilanData] = useState(null);
  const [quotidienData, setQuotidienData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [periode, setPeriode] = useState('mois');
  const [typeBilan, setTypeBilan] = useState('periode');
  const [expandedSections, setExpandedSections] = useState({
    distribution: true,
    produits: true,
    stats: true
  });

  const TVA_ENABLED = process.env.REACT_APP_FEATURE_FLIPPING_TVA === 'true';

  const periodes = [
    { key: 'jour', label: "Aujourd'hui", icon: '📅' },
    { key: 'mois', label: 'Ce mois', icon: '📆' },
    { key: 'annee', label: 'Cette année', icon: '📊' }
  ];

  useEffect(() => {
    fetchData();
  }, [periode, typeBilan]);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      if (typeBilan === 'quotidien') {
        const response = await BilanService.getBilanQuotidienAuto();
        setQuotidienData(response.data);
        setBilanData(null);
      } else {
        const response = await BilanService.getBenefices(periode);
        setBilanData(response.data);
        setQuotidienData(null);
      }
    } catch (error) {
      setError('Erreur lors du chargement du bilan');
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  // Fonctions utilitaires pour formater la marge
  const formatMarge = (marge) => {
    if (marge === undefined || marge === null) return '0.0';
    
    // Si c'est déjà un nombre
    if (typeof marge === 'number') {
      return marge.toFixed(1);
    }
    
    // Si c'est une chaîne comme "45.67%"
    if (typeof marge === 'string') {
      // Enlever le % et convertir en nombre
      const numericValue = parseFloat(marge.replace('%', ''));
      if (!isNaN(numericValue)) {
        return numericValue.toFixed(1);
      }
    }
    
    // Si c'est un nombre dans une chaîne
    const parsed = parseFloat(marge);
    if (!isNaN(parsed)) {
      return parsed.toFixed(1);
    }
    
    return '0.0';
  };

  const getMargeValue = (marge) => {
    if (marge === undefined || marge === null) return 0;
    
    if (typeof marge === 'number') return marge;
    
    if (typeof marge === 'string') {
      const numericValue = parseFloat(marge.replace('%', ''));
      if (!isNaN(numericValue)) return numericValue;
    }
    
    const parsed = parseFloat(marge);
    return !isNaN(parsed) ? parsed : 0;
  };

  const FormattedMontant = ({ montant, type = 'ttc' }) => {
    if (montant === undefined || montant === null) return null;
    
    const suffix = TVA_ENABLED && type === 'ht' ? ' HT' : TVA_ENABLED && type === 'ttc' ? ' TTC' : '';
    
    return (
      <Box display="flex" alignItems="center" gap={0.5} flexWrap="wrap">
        <Typography component="span" style={{ fontWeight: 600 }}>
          <CountUp 
            start={0} 
            end={montant} 
            duration={1.5} 
            separator=" " 
            suffix=" F CFA"
          />
        </Typography>
        {suffix && (
          <Chip 
            size="small" 
            label={suffix.trim()} 
            className={classes.chipModern}
            style={{ 
              backgroundColor: type === 'ht' ? '#e0f2fe' : '#dcfce7',
              color: type === 'ht' ? '#0369a1' : '#166534'
            }}
          />
        )}
      </Box>
    );
  };

  const getPourcentage = (valeur, total) => {
    if (!total || total === 0) return 0;
    return ((valeur / total) * 100).toFixed(1);
  };

  if (loading) {
    return (
      <div className={classes.loadingContainer}>
        <CircularProgress size={60} thickness={4} style={{ color: '#3b82f6' }} />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      {/* Header */}
      <div className={classes.header}>
        <div className={classes.title}>
          <Avatar className={classes.avatarIcon}>
            <Assessment />
          </Avatar>
          <Box>
            <Typography variant="h5" style={{ fontWeight: 700, color: '#0f172a' }}>
              Tableau de bord financier
            </Typography>
            <Typography variant="body2" style={{ color: '#64748b' }}>
              Analysez vos performances en temps réel
            </Typography>
          </Box>
          {TVA_ENABLED && (
            <div className={classes.tvaBadge}>
              <ReceiptIcon style={{ fontSize: 14 }} />
              TVA incluse
            </div>
          )}
        </div>

        <div className={classes.controls}>
          <FormControl variant="outlined" className={classes.selectControl}>
            <Select
              value={typeBilan}
              onChange={(e) => setTypeBilan(e.target.value)}
              displayEmpty
            >
              <MenuItem value="periode">📊 Bilan par période</MenuItem>
              <MenuItem value="quotidien">📅 Bilan quotidien</MenuItem>
            </Select>
          </FormControl>
          
          {typeBilan === 'periode' && (
            <FormControl variant="outlined" className={classes.selectControl}>
              <Select
                value={periode}
                onChange={(e) => setPeriode(e.target.value)}
              >
                {periodes.map((p) => (
                  <MenuItem key={p.key} value={p.key}>
                    {p.icon} {p.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          <IconButton onClick={fetchData} style={{ backgroundColor: 'white', borderRadius: 12 }}>
            <Refresh />
          </IconButton>
        </div>
      </div>

      {error && (
        <div className={classes.errorContainer}>
          <Box display="flex" alignItems="center" gap={2}>
            <ErrorIcon style={{ color: '#ef4444' }} />
            <Typography>{error}</Typography>
          </Box>
          <Button variant="contained" color="primary" onClick={fetchData}>
            Réessayer
          </Button>
        </div>
      )}

      {/* Bilan par Période */}
      {typeBilan === 'periode' && bilanData && (
        <Grid container spacing={3}>
          {/* KPIs Principaux */}
          <Grid item xs={12} md={4}>
            <Card className={classes.statCard}>
              <CardContent className={classes.statContent}>
                <AttachMoney className={classes.statIcon} style={{ color: '#10b981' }} />
                <Typography className={classes.statLabel}>
                  Chiffre d'affaires {TVA_ENABLED ? 'TTC' : ''}
                </Typography>
                <Typography className={classes.statValue}>
                  <FormattedMontant 
                    montant={TVA_ENABLED ? bilanData.chiffre_affaires.totalVentes : bilanData.chiffre_affaires.totalHT } 
                    type={TVA_ENABLED ? 'ttc' : 'ht'}
                  />
                </Typography>
                <Box display="flex" alignItems="center" gap={1} flexWrap="wrap" mt={2}>
                  <Chip 
                    size="small" 
                    icon={<TrendingUp />}
                    label={`${bilanData.chiffre_affaires.nombreVentes} ventes`}
                    className={classes.chipModern}
                    style={{ backgroundColor: '#e0f2fe', color: '#0369a1' }}
                  />
                  <Chip 
                    size="small" 
                    icon={<ShoppingCart />}
                    label={`${bilanData.chiffre_affaires.quantiteVendue} articles`}
                    className={classes.chipModern}
                    style={{ backgroundColor: '#fef9c3', color: '#854d0e' }}
                  />
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card className={classes.statCard}>
              <CardContent className={classes.statContent}>
                <TrendingUp className={classes.statIcon} style={{ color: '#3b82f6' }} />
                <Typography className={classes.statLabel}>Bénéfice brut</Typography>
                <Typography className={classes.statValue}>
                  <FormattedMontant montant={bilanData.benefice_brut} />
                </Typography>
                <div className={classes.statTrend}>
                  <Typography variant="body2" style={{ color: '#64748b' }}>
                    Marge
                  </Typography>
                  <Typography className={classes.positive}>
                    {bilanData.marge_brute}
                  </Typography>
                </div>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card className={classes.statCard}>
              <CardContent className={classes.statContent}>
                <ShoppingCart className={classes.statIcon} style={{ color: '#f59e0b' }} />
                <Typography className={classes.statLabel}>Coût marchandises</Typography>
                <Typography className={classes.statValue}>
                  <FormattedMontant montant={bilanData.cout_marchandises_vendues.totalCout} />
                </Typography>
                <Chip 
                  size="small" 
                  label={`${bilanData.cout_marchandises_vendues.nombreProduits} produits`}
                  className={classes.chipModern}
                  style={{ backgroundColor: '#f1f5f9', color: '#475569' }}
                />
              </CardContent>
            </Card>
          </Grid>

          {/* Distribution des ventes */}
          <Grid item xs={12} md={6}>
            <Card className={classes.statCard}>
              <CardContent>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Typography variant="h6" style={{ fontWeight: 600 }}>
                    <PieChartIcon style={{ marginRight: 8, color: '#3b82f6' }} />
                    Distribution par mode
                  </Typography>
                  <IconButton size="small" onClick={() => toggleSection('distribution')}>
                    {expandedSections.distribution ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                </Box>
                
                <Collapse in={expandedSections.distribution}>
                  <Box mt={2}>
                    {bilanData.chiffre_affaires.par_mode_paiement.map((item) => {
                      const total = TVA_ENABLED ? item.totalTTC : item.totalHT;
                      const pourcentage = getPourcentage(total, bilanData.chiffre_affaires.totalVentes);
                      const color = CHART_COLORS[item.mode_payement] || CHART_COLORS.default;
                      
                      return (
                        <Box key={item.mode_payement} className={classes.distributionItem}>
                          <Box display="flex" alignItems="center">
                            <Box className={classes.colorDot} style={{ backgroundColor: color }} />
                            <Typography variant="body2" style={{ fontWeight: 500 }}>
                              {item.mode_payement}
                            </Typography>
                          </Box>
                          <Box textAlign="right">
                            <Typography variant="body2" style={{ fontWeight: 600 }}>
                              <FormattedMontant montant={total} />
                            </Typography>
                            <Typography variant="caption" style={{ color: '#64748b' }}>
                              {pourcentage}%
                            </Typography>
                          </Box>
                        </Box>
                      );
                    })}
                    
                    {/* Barres de progression */}
                    <Box mt={2}>
                      {bilanData.chiffre_affaires.par_mode_paiement.map((item) => {
                        const total = TVA_ENABLED ? item.totalTTC : item.totalHT;
                        const pourcentage = getPourcentage(total, bilanData.chiffre_affaires.totalVentes);
                        const color = CHART_COLORS[item.mode_payement] || CHART_COLORS.default;
                        
                        return (
                          <Box key={`progress-${item.mode_payement}`} mb={1.5}>
                            <Box display="flex" justifyContent="space-between" mb={0.5}>
                              <Typography variant="caption">{item.mode_payement}</Typography>
                              <Typography variant="caption" style={{ fontWeight: 600 }}>
                                {pourcentage}%
                              </Typography>
                            </Box>
                            <LinearProgress
                              variant="determinate"
                              value={parseFloat(pourcentage)}
                              className={classes.progressBar}
                              style={{ backgroundColor: '#eef2f6' }}
                              classes={{ bar: classes.progressBar }}
                            />
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                </Collapse>
              </CardContent>
            </Card>
          </Grid>

          {/* Statistiques clés */}
          <Grid item xs={12} md={6}>
            <Card className={classes.statCard}>
              <CardContent>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Typography variant="h6" style={{ fontWeight: 600 }}>
                    <BarChartIcon style={{ marginRight: 8, color: '#f59e0b' }} />
                    Indicateurs clés
                  </Typography>
                  <IconButton size="small" onClick={() => toggleSection('stats')}>
                    {expandedSections.stats ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                </Box>
                
                <Collapse in={expandedSections.stats}>
                  <Grid container spacing={2} mt={1}>
                    <Grid item xs={6}>
                      <div className={classes.metricCard}>
                        <People style={{ color: '#3b82f6', fontSize: 32, marginBottom: 8 }} />
                        <Typography variant="h5" style={{ fontWeight: 700 }}>
                          {bilanData.statistiques.total_vendeurs}
                        </Typography>
                        <Typography variant="caption" style={{ color: '#64748b' }}>
                          Vendeurs actifs
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={6}>
                      <div className={classes.metricCard}>
                        <People style={{ color: '#10b981', fontSize: 32, marginBottom: 8 }} />
                        <Typography variant="h5" style={{ fontWeight: 700 }}>
                          {bilanData.statistiques.total_clients}
                        </Typography>
                        <Typography variant="caption" style={{ color: '#64748b' }}>
                          Clients
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <div className={classes.metricCard}>
                        <EuroSymbol style={{ color: '#8b5cf6', fontSize: 32, marginBottom: 8 }} />
                        <Typography variant="h5" style={{ fontWeight: 700 }}>
                          <FormattedMontant montant={bilanData.chiffre_affaires.moyenneParVente} />
                        </Typography>
                        <Typography variant="caption" style={{ color: '#64748b' }}>
                          Panier moyen {TVA_ENABLED ? 'TTC' : ''}
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                </Collapse>
              </CardContent>
            </Card>
          </Grid>

          {/* Tableau des produits */}
          <Grid item xs={12}>
            <Card className={classes.statCard}>
              <CardContent>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Typography variant="h6" style={{ fontWeight: 600 }}>
                    <Star style={{ marginRight: 8, color: '#f59e0b' }} />
                    Top produits
                  </Typography>
                  <IconButton size="small" onClick={() => toggleSection('produits')}>
                    {expandedSections.produits ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                </Box>
                
                <Collapse in={expandedSections.produits}>
                  <TableContainer component={Paper} className={classes.tableContainer} style={{ marginTop: 16 }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Produit</TableCell>
                          <TableCell align="right">Quantité</TableCell>
                          <TableCell align="right">CA {TVA_ENABLED ? '(TTC)' : ''}</TableCell>
                          <TableCell align="right">Bénéfice</TableCell>
                          <TableCell align="right">Marge</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {bilanData.benefices_par_produit.slice(0, 5).map((produit, index) => {
                          const margeValue = getMargeValue(produit.marge);
                          const margeFormatted = formatMarge(produit.marge);
                          
                          return (
                            <TableRow key={index} className={classes.productRow}>
                              <TableCell>
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Avatar style={{ 
                                    width: 24, 
                                    height: 24, 
                                    fontSize: 12,
                                    backgroundColor: index === 0 ? '#f59e0b' : index === 1 ? '#3b82f6' : index === 2 ? '#10b981' : '#94a3b8'
                                  }}>
                                    {index + 1}
                                  </Avatar>
                                  {produit.nomProd}
                                </Box>
                              </TableCell>
                              <TableCell align="right">{produit.quantiteVendue}</TableCell>
                              <TableCell align="right">
                                <FormattedMontant montant={produit.chiffreAffaires} />
                              </TableCell>
                              <TableCell align="right" className={classes.positive}>
                                <FormattedMontant montant={produit.benefice} />
                              </TableCell>
                              <TableCell align="right">
                                <Chip 
                                  label={`${margeFormatted}%`}
                                  className={classes.chipModern}
                                  style={{ 
                                    backgroundColor: margeValue > 20 ? '#dcfce7' : '#fef9c3',
                                    color: margeValue > 20 ? '#166534' : '#854d0e'
                                  }}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Collapse>
              </CardContent>
            </Card>
          </Grid>

          {/* TVA Details si activée */}
          {TVA_ENABLED && bilanData.chiffre_affaires.totalTVA > 0 && (
            <Grid item xs={12}>
              <Card className={classes.statCard}>
                <CardContent>
                  <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 16 }}>
                    <ReceiptIcon style={{ marginRight: 8, color: '#8b5cf6' }} />
                    Détail TVA
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <div className={classes.miniCard}>
                        <Typography variant="caption" style={{ color: '#64748b' }}>
                          Total HT
                        </Typography>
                        <Typography variant="h6" style={{ fontWeight: 700, color: '#3b82f6' }}>
                          <FormattedMontant montant={bilanData.chiffre_affaires.totalHT} type="ht" />
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <div className={classes.miniCard}>
                        <Typography variant="caption" style={{ color: '#64748b' }}>
                          TVA collectée
                        </Typography>
                        <Typography variant="h6" style={{ fontWeight: 700, color: '#8b5cf6' }}>
                          <FormattedMontant montant={bilanData.chiffre_affaires.totalTVA} />
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <div className={classes.miniCard}>
                        <Typography variant="caption" style={{ color: '#64748b' }}>
                          Total TTC
                        </Typography>
                        <Typography variant="h6" style={{ fontWeight: 700, color: '#10b981' }}>
                          <FormattedMontant montant={bilanData.chiffre_affaires.totalTTC} type="ttc" />
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>
      )}

      {/* Bilan Quotidien */}
      {typeBilan === 'quotidien' && quotidienData && (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card className={classes.statCard}>
              <CardContent>
                <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 16 }}>
                  📊 Comparaison quotidienne
                </Typography>
                
                {/* Indicateur d'évolution */}
                <Box mb={3}>
                  <Chip
                    icon={quotidienData.evolution.chiffre_affaires.includes('+') ? <TrendingUp /> : <TrendingDown />}
                    label={`Évolution du CA: ${quotidienData.evolution.chiffre_affaires}`}
                    style={{ 
                      backgroundColor: quotidienData.evolution.chiffre_affaires.includes('+') ? '#dcfce7' : '#fee2e2',
                      color: quotidienData.evolution.chiffre_affaires.includes('+') ? '#166534' : '#991b1b',
                      padding: '8px 16px',
                      fontSize: '1rem'
                    }}
                  />
                </Box>

                <Grid container spacing={3}>
                  {/* Aujourd'hui */}
                  <Grid item xs={12} md={6}>
                    <div className={classes.miniCard}>
                      <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                          📅 Aujourd'hui
                        </Typography>
                        <Chip 
                          label="Jour J"
                          size="small"
                          style={{ backgroundColor: '#3b82f6', color: 'white' }}
                        />
                      </Box>
                      
                      <Typography variant="h5" style={{ fontWeight: 700, color: '#10b981', marginBottom: 16 }}>
                        <FormattedMontant montant={quotidienData.aujourdhui.chiffre_affaires.totalVentes} />
                      </Typography>
                      
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Typography variant="caption" style={{ color: '#64748b' }}>
                            Ventes
                          </Typography>
                          <Typography variant="h6" style={{ fontWeight: 600 }}>
                            {quotidienData.aujourdhui.chiffre_affaires.nombreVentes}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="caption" style={{ color: '#64748b' }}>
                            Articles
                          </Typography>
                          <Typography variant="h6" style={{ fontWeight: 600 }}>
                            {quotidienData.aujourdhui.chiffre_affaires.quantiteVendue}
                          </Typography>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>

                  {/* Hier */}
                  <Grid item xs={12} md={6}>
                    <div className={classes.miniCard}>
                      <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                          📆 Hier
                        </Typography>
                        <Chip 
                          label="Jour J-1"
                          size="small"
                          variant="outlined"
                        />
                      </Box>
                      
                      <Typography variant="h5" style={{ fontWeight: 700, color: '#64748b', marginBottom: 16 }}>
                        <FormattedMontant montant={quotidienData.hier.chiffre_affaires.totalVentes} />
                      </Typography>
                      
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Typography variant="caption" style={{ color: '#64748b' }}>
                            Ventes
                          </Typography>
                          <Typography variant="h6" style={{ fontWeight: 600 }}>
                            {quotidienData.hier.chiffre_affaires.nombreVentes}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="caption" style={{ color: '#64748b' }}>
                            Articles
                          </Typography>
                          <Typography variant="h6" style={{ fontWeight: 600 }}>
                            {quotidienData.hier.chiffre_affaires.quantiteVendue}
                          </Typography>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                </Grid>

                {/* Détails TVA pour le quotidien si activée */}
                {TVA_ENABLED && quotidienData.aujourdhui.chiffre_affaires.totalTVA > 0 && (
                  <Box mt={3}>
                    <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 12 }}>
                      Détails TVA - Aujourd'hui
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={4}>
                        <Typography variant="caption" style={{ color: '#64748b' }}>HT</Typography>
                        <Typography variant="body2" style={{ fontWeight: 600, color: '#3b82f6' }}>
                          <FormattedMontant montant={quotidienData.aujourdhui.chiffre_affaires.totalHT} type="ht" />
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="caption" style={{ color: '#64748b' }}>TVA</Typography>
                        <Typography variant="body2" style={{ fontWeight: 600, color: '#8b5cf6' }}>
                          <FormattedMontant montant={quotidienData.aujourdhui.chiffre_affaires.totalTVA} />
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="caption" style={{ color: '#64748b' }}>TTC</Typography>
                        <Typography variant="body2" style={{ fontWeight: 600, color: '#10b981' }}>
                          <FormattedMontant montant={quotidienData.aujourdhui.chiffre_affaires.totalTTC} type="ttc" />
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        message={error}
        action={
          <Button color="primary" size="small" onClick={() => setSnackbarOpen(false)}>
            Fermer
          </Button>
        }
      />
    </div>
  );
}

export default Bilan;